import React, { useMemo, useState } from "react";
import {
	Stack,
	Typography,
	ToggleButton,
	ToggleButtonGroup,
	useMediaQuery,
	useTheme,
} from "@mui/material";
import { PageContainer } from "../components/Container/PageContainer";
import { CardContainerRetro } from "../components/Container/CardContainerRetro";
import { PlanCard } from "../components/pricing/PlanCard";
import pricingPlans from "../data/pricingPlans.json";
import { useTranslation } from "react-i18next";

const Pricing = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const [billingMode, setBillingMode] = useState("monthly");
	const plans = pricingPlans.plans ?? [];

	const billingOptions = useMemo(
		() => [
			{ value: "monthly", label: t("pricing.billingToggle.monthly") },
			{ value: "yearly", label: t("pricing.billingToggle.yearly") },
		],
		[t]
	);

	const handleBillingChange = (_event, nextValue) => {
		if (nextValue !== null) {
			setBillingMode(nextValue);
		}
	};

	return (
		<PageContainer>
			<Stack spacing={6} sx={{ width: "100%" }}>
				<Typography
					variant={isMobile ? "body1" : "h6"}
					color="primary"
					fontWeight={600}
					textAlign="center"
					sx={{ width: "100%" }}
				>
					{t("pricing.banner")}
				</Typography>

				<Stack spacing={1} alignItems="center" textAlign="center">
					<Typography variant="h3" fontWeight={700} color="text.primary">
						{t("pricing.title")}
					</Typography>
					<Typography variant="subtitle1" color="text.secondary">
						{t("pricing.subtitle")}
					</Typography>
				</Stack>
				<Stack alignItems="center">
					<ToggleButtonGroup
						value={billingMode}
						exclusive
						onChange={handleBillingChange}
						sx={{
							backgroundColor: "rgba(99, 102, 241, 0.08)",
							borderRadius: "999px",
							padding: "4px",
						}}
					>
						{billingOptions.map((option) => (
							<ToggleButton
								key={option.value}
								value={option.value}
								sx={{
									textTransform: "none",
									padding: isMobile ? "6px 14px" : "8px 20px",
									border: "none",
									borderRadius: "999px",
									"&.Mui-selected": {
										color: theme.palette.primary.contrastText,
										backgroundColor: theme.palette.primary.main,
									},
								}}
							>
								<Typography variant="body2" fontWeight={600}>
									{option.label}
								</Typography>
							</ToggleButton>
						))}
					</ToggleButtonGroup>
				</Stack>
				<Stack
					direction={{ xs: "column", md: "row" }}
					spacing={3}
					alignItems={{ xs: "stretch", md: "flex-start" }}
				>
					{plans.map((plan) => (
						<PlanCard
							key={plan.id}
							plan={plan}
							billingMode={billingMode}
							isMobile={isMobile}
						/>
					))}
				</Stack>
			</Stack>
		</PageContainer>
	);
};

export default Pricing;
